import React from 'react';
import CountUp from '~/components/CountUp';

function Counter({ numberPrefix, numberSuffix, number, label, numberContainerClassName, numberClassName }) {
  return (
    <div className="flex flex-col pt-32 mb-5 pr-7 bg-light-grey pl-7 pb-7 ">
      <div className={`text-blue text-72px md:text-135px font-semibold font-heading flex items-center`} style={{ lineHeight: '1.1' }}>
        <div className="">{numberPrefix}</div>
        <CountUp endNumber={number} numberContainerClassName={numberContainerClassName} numberClassName={numberClassName} />
        <div className="">{numberSuffix}</div>
      </div>
      <div className={`u-h3 text-32px font-normal tracking-2 lead`} style={{ lineHeight: '1.42' }}>
        {label}
      </div>
    </div>
  );
}

export default Counter;
